import React from 'react';
import PlusIcon from "../../../../Assets/PlusIcon/Add.svg";
import MembersList from './MembersList/MembersList';
import { useDispatch } from 'react-redux';
import { setSettingsModal } from '../../../../Features/settingsSlice';

function ManageMembers() {
    const dispatch = useDispatch();

    function handleInviteMembers() {
        dispatch(setSettingsModal('invite-members'));
    }

    return (
        <div className='w-full flex flex-col gap-4'>
            <div className="flex flex-col gap-4">
                <div className="flex items-center justify-between">
                    <h1 className='font-semibold text-[20px] leading-6 text-[#121212]'>Manage Members</h1>

                    <button onClick={handleInviteMembers} className='outline-none flex items-center gap-[2px] p-[8px_16px_8px_10px] bg-primaryColor hover:bg-primaryAccent font-semibold text-base text-buttonText rounded'>
                        <div className="size-6 flex items-center justify-center">
                            <img src={PlusIcon} alt="" />
                        </div>

                        Invite members
                    </button>
                </div>

                <MembersList />
            </div>
        </div>
    );
}

export default ManageMembers;
